import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { t } from '../utils/translations';

export default function LanguageSwitcher() {
  const { language, toggleLanguage } = useLanguage();

  return (
    <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
      <button
        onClick={() => toggleLanguage('sindhi')}
        className={`btn btn-sm ${language === 'sindhi' ? 'btn-primary' : 'btn-outline'}`}
        style={{
          padding: '8px 16px',
          borderRadius: '6px',
          fontSize: '13px',
          fontWeight: '600',
          cursor: 'pointer',
          border: 'none',
          transition: 'all 0.2s'
        }}
        title="سندھي" 
      >
        {t('sindhi', language)}
      </button>
      <button
        onClick={() => toggleLanguage('english')}
        className={`btn btn-sm ${language === 'english' ? 'btn-primary' : 'btn-outline'}`}
        style={{
          padding: '8px 16px',
          borderRadius: '6px',
          fontSize: '13px',
          fontWeight: '600',
          cursor: 'pointer',
          border: 'none',
          transition: 'all 0.2s'
        }}
        title="English"
      >
        {t('english', language)}
      </button>
    </div>
  );
}
